import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es para principiantes?',
  a: 'Sí, está diseñado especialmente para personas que quieren empezar desde cero y no tienen experiencia previa con rutinas de cuidado facial.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No, todo está explicado paso a paso, de forma clara y sencilla para que cualquiera pueda seguirlo.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'Inmediatamente después de tu compra. Recibirás acceso al instante para que puedas empezar de inmediato.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-22">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-24">
          <h2 className="text-4xl font-medium text-brown mb-4" data-id="element-25">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border border-beige rounded-2xl overflow-hidden bg-cream/30" data-id="element-27">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-28">
                <span className="font-medium text-brown text-lg" data-id="element-29">{faq.q}</span>
                <ChevronDown className={`text-olive transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-30" />
              </button>
              <AnimatePresence data-id="element-31">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-32">
                    <div className="px-6 pb-5 text-brown/70 font-light" data-id="element-33">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}